<template>
  <div class="medication-list">
    <medication-list-item
      v-for="medication in medications"
      :key="`${type}-${medication.id}`"
      :retain-prescription="retainPrescription"
      :exist-dispenses="existDispenses"
      :fetching-ref-sets="fetchingRefSets"
      :medication="medication"
      :type="type"
      :selected="isSelected(medication.id)"
      :processing="processingMedicationDispenses.includes(medication.id)"
      @select="handleMedicationDispenseSelect"
      @medication-dispense="handleMedicationDispense"
      @medication-dispense-edit="handleMedicationDispenseEdit"
      @medication-dispense-delete="handleMedicationDispenseDelete"
      @show-previous-dispenses="$emit('show-previous-dispenses', $event)" />
    <div v-if="type === 'medication-dispense'" class="medication-list__footer">
      <el-button :disabled="!selectedMedications.length" type="warning" @click="handleClickDeleteMedication">
        Eliminar Seleccionados
      </el-button>
      <el-button type="primary" @click="handleClickGenerateMedicationDispense">
        Confirmar Dispensación
      </el-button>
    </div>
  </div>
</template>

<script>
import MedicationListItem from '@/components/medication/MedicationListItem';
export default {
  name: 'MedicationList',
  components: { MedicationListItem },
  props: {
    medications: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'medication-request'
    },
    processingMedicationDispenses: {
      type: Array,
      default() {
        return [];
      }
    },
    retainPrescription: {
      type: Boolean,
      default: false
    },
    existDispenses: {
      type: Boolean,
      default: false
    },
    fetchingRefSets: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedMedications: []
    };
  },
  methods: {
    handleMedicationDispense(medication) {
      this.$emit('medication-dispense', medication);
    },
    handleMedicationDispenseEdit(medication) {
      this.$emit('medication-dispense-edit', medication);
    },
    handleMedicationDispenseDelete(medication) {
      this.handleMedicationDispenseSelect(medication.id);
      this.handleClickDeleteMedication();
      this.$emit('medication-dispense-delete', medication);
    },
    handleMedicationDispenseSelect(medicationId) {
      if (this.isSelected(medicationId)) {
        this.selectedMedications.splice(this.selectedMedications.findIndex(m => m.id === medicationId), 1);
      } else {
        this.selectedMedications.push(medicationId);
      }
    },
    isSelected(medicationId) {
      return this.selectedMedications.includes(medicationId);
    },
    handleClickDeleteMedication() {
      this.$emit('delete-medications', this.selectedMedications, this.type);
      this.selectedMedications.splice(0);
    },
    handleClickGenerateMedicationDispense() {
      this.$emit('save-medication-dispense');
    }
  }
};
</script>

<style lang="scss">
.medication-list {
  &-item {
    margin-bottom: $--spacing-4;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
  }
}
</style>
